var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38645 14.4785C3.02458 14.6642 2.61395 14.3388 2.68708 13.9235L3.4652 9.48915L0.16239 6.3429C-0.146048 6.04853 0.0142649 5.5104 0.427702 5.45228L5.01958 4.79978L7.06708 0.743213C7.25177 0.377588 7.75145 0.377588 7.93614 0.743213L9.98364 4.79978L14.5755 5.45228C14.989 5.5104 15.1493 6.04853 14.8399 6.3429L11.538 9.48915L12.3161 13.9235C12.3893 14.3388 11.9786 14.6642 11.6168 14.4785L7.5002 12.3635L3.38551 14.4785H3.38645Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGreyIcon);
export default __webpack_public_path__ + "static/media/star-grey-icon.154d01656bd6edb5503654ba91ce4231.svg";
export { ForwardRef as ReactComponent };